export default __webpack_public_path__ + "3634db5994067933c9dd00bb3e8e69e4.png";